import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/models/constants';
import { Observable, of } from 'rxjs';
import { GetUpoInput, ReportInput, FetchMessageLastCallRequest } from 'src/app/postlogin/invoicemanagement/invoicemanagement.component';
import { StorageService } from '../storage.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class InvoiceManagementService {
  userEmail: any;
    /**
   * Unicode-safe base64 encoding that handles characters outside Latin1 range (e.g., Polish, Arabic, etc.)
   * @param str - String to encode
   * @returns Base64 encoded string
   */
  private unicodeSafeBase64Encode(str: string): string {
    // Convert Unicode string to UTF-8 encoded URI component, then to base64
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    }));
  }

  constructor(private httpClient: HttpClient,private authService: MsalService, private storageService: StorageService,) { }
  getEinvoiceData(selectedCriteria: string, fromDate: string, toDate: string,
    selectedEntity: string, selectedStatus: string, selectedInvType: string, userId: string, sourceType: string, country: string, pageCount: any, pageSize: any, filterData: any, fileId: string, sortData: any,columnFilters:any,columnSort:any, fromDateAndTime, toDateAndTime, frFilters?: {
      lifecycleStatus?: string;
      lifecycleActionStatus?: string;
      ppfStatus?: string;
      documentNumber?: string;
      buyerName?: string;
      buyerVatId?: string;
      sellerName?: string;
      sellerVatId?: string;
      currency?: string;
      attachmentExists?: string;
      transactionType?: string;
      transactionSubcategory?: string;
    }): Observable<any> {
      if (country == 'MY') {
      let reqBody = {
        selectedCriteria: selectedCriteria,
        ...(selectedCriteria != 'FileID' && { fromDataReceivedDate: fromDate || null }),
        ...(selectedCriteria != 'FileID' && { toDataReceivedDate: toDate || null }),
        filterType: 's',
        selectedEntity: selectedEntity,
        selectedStatus: selectedStatus || 'ALL',
        selectedInvType: selectedInvType || 'ALL',
        selectedSourceType: sourceType || 'ALL',
        selectedUserId: userId,
        pageCount: pageCount,
        pageSize: pageSize,
        filters: filterData,
        sort: sortData,
        fromDateAndTime: fromDateAndTime,
        toDateAndTime: toDateAndTime,
        ...(country == 'MY' && selectedCriteria == 'FileID' && { fileId: fileId })
      }

      const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
      const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
      return this.httpClient.post<any>(url, reqBody);
    } else if (country === 'PL') {
      const payload = {
        selectedCriteria: selectedCriteria || null,
        ...(selectedCriteria != 'FileID' && { fromDataReceivedDate: fromDate || null }),
        ...(selectedCriteria != 'FileID' && { toDataReceivedDate: toDate || null }),
        ...(selectedCriteria != 'FileID'  && { fromDateAndTime: fromDateAndTime }),
        ...(selectedCriteria != 'FileID' && { toDateAndTime: toDateAndTime }),
        filterType:'S',
        selectedEntity: selectedEntity,
        selectedStatus: selectedStatus || 'ALL',
        selectedInvType: selectedInvType || 'ALL',
        selectedSourceType: sourceType || 'ALL',
        selectedUserId: userId,
        pageCount: pageCount,
        pageSize: pageSize,
        filters: columnFilters,
        sort: columnSort,
        ...(selectedCriteria == 'FileID' && { fileId: fileId })
      };

      const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
      const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
       return this.httpClient.post<any>(url, payload);

    } else if(country == 'RO') {
      let reqs = new HttpParams();

      const payload = {
        selectedCriteria: selectedCriteria || null,
        ...(selectedCriteria != 'FileID' && { fromDataReceivedDate: fromDate || null }),
        ...(selectedCriteria != 'FileID' && { toDataReceivedDate: toDate || null }),
        filterType:'S',
        selectedEntity: selectedEntity,
        selectedStatus: selectedStatus || 'ALL',
        selectedInvType: selectedInvType || 'ALL',
        selectedSourceType: sourceType || 'ALL',
        selectedUserId: userId,
        pageCount: pageCount,
        pageSize: pageSize,
        filters: columnFilters,
        sort: columnSort,
        ...(selectedCriteria == 'FileID' && { fileId: fileId })
      };
      let header = new HttpHeaders({ 'country': country });

      const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
      const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
      return this.httpClient.post<any>(url, payload);
    } else if(country == 'IT'){
        let reqBody = {
            selectedCriteria: selectedCriteria,
            ...(selectedCriteria != 'FileID' && { fromDataReceivedDate: fromDate || null }),
            ...(selectedCriteria != 'FileID' && { toDataReceivedDate: toDate || null }),
            filterType: 's',
            selectedEntity: selectedEntity,
            selectedStatus: selectedStatus || 'ALL',
            selectedInvType: selectedInvType || 'ALL',
            selectedSourceType: sourceType || 'ALL',
            selectedUserId: userId,
            pageCount: pageCount,
            pageSize: pageSize,
            filters: columnFilters,
            sort: columnSort,
            ...(country == 'IT' && selectedCriteria == 'FileID' && { fileId: fileId })
          }
          
        let header = new HttpHeaders({ 'country': country });
  
        const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
        const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
        console.log(reqBody)
      return this.httpClient.post<any>(url, reqBody, { headers: header });

    } else if (country == 'FR') {
      let reqs = new HttpParams();
      reqs = reqs.append('fromDataReceivedDate', fromDate || null)
      reqs = reqs.append('toDataReceivedDate', toDate || null)
      reqs = reqs.append('selectedCriteria', selectedCriteria || 'DataReceivedDate');
      reqs = reqs.append('filterType', 's');
      reqs = reqs.append('selectedEntity', selectedEntity || '');
      reqs = reqs.append('selectedStatus', selectedStatus || 'ALL');
      reqs = reqs.append('selectedInvType', selectedInvType || 'ALL');
      reqs = reqs.append('selectedSourceType', sourceType || 'ALL');
      reqs = reqs.append('selectedUserId', userId || '');
      reqs = reqs.append('pageCount', pageCount ?? '');
      reqs = reqs.append('pageSize', pageSize ?? '');
      reqs = reqs.append('filters', JSON.stringify(filterData || []));
      reqs = reqs.append('sort', JSON.stringify(sortData || []));
      reqs = reqs.append('fromDateAndTime', fromDateAndTime || '');
      reqs = reqs.append('toDateAndTime', toDateAndTime || '');
      reqs = reqs.append('lifecycleStatus', frFilters?.lifecycleStatus || 'ALL');
      reqs = reqs.append('lifecycleActionStatus', frFilters?.lifecycleActionStatus || '');
      reqs = reqs.append('ppfStatus', frFilters?.ppfStatus || '');
      reqs = reqs.append('documentNumber', frFilters?.documentNumber || '');
      reqs = reqs.append('buyerName', frFilters?.buyerName || '');
      reqs = reqs.append('buyerVatId', frFilters?.buyerVatId || '');
      reqs = reqs.append('sellerName', frFilters?.sellerName || '');
      reqs = reqs.append('sellerVatId', frFilters?.sellerVatId || '');
      reqs = reqs.append('currency', frFilters?.currency || 'ALL');
      reqs = reqs.append('attachmentExists', frFilters?.attachmentExists || 'ALL');
      reqs = reqs.append('transactionType', frFilters?.transactionType || 'ALL');
      reqs = reqs.append('transactionSubcategory', frFilters?.transactionSubcategory || '');
      reqs = reqs.append('fileId', fileId || '');

      const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
      const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
      return this.httpClient.post<any>(url, reqs);
    }else {
        let reqs = new HttpParams();
  
        reqs = reqs.append('selectedCriteria', selectedCriteria || 'DataReceivedDate')
        if (selectedCriteria != 'FileID') {
          reqs = reqs.append('fromDataReceivedDate', fromDate || null)
          reqs = reqs.append('toDataReceivedDate', toDate || null)
        }
        reqs = reqs.append('filterType', 'S')
        reqs = reqs.append('selectedEntity', selectedEntity)
        reqs = reqs.append('selectedStatus', selectedStatus || 'ALL')
        reqs = reqs.append('selectedInvType', selectedInvType || 'ALL');
        reqs = reqs.append('selectedSourceType', sourceType || 'ALL');
        reqs = reqs.append('selectedUserId', userId);
        if (country == 'MY' && selectedCriteria == 'FileID') reqs = reqs.append('fileId', fileId);
  
        let header = new HttpHeaders({ 'country': country });
  
        const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
        
        const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
   
        return this.httpClient.post<any>(url, reqs, { headers: header });
  }
    
  }

  getConsolidatedData(selectedCriteria: string, fromDate: string, toDate: string,
    selectedEntity: string, selectedStatus: string, selectedInvType: string, userId: string, sourceType: string, country: string, pageCount: any, pageSize: any, filterData: any, fileId: string, sortData: any, conSolidatedData: any, fromDateAndTime, toDateAndTime): Observable<any> {
    if (country == 'MY') {
      let reqBody = {
        selectedCriteria: selectedCriteria,
        ...(selectedCriteria != 'FileID' && { fromDataReceivedDate: fromDate || null }),
        ...(selectedCriteria != 'FileID' && { toDataReceivedDate: toDate || null }),
        filterType: 's',
        selectedEntity: selectedEntity,
        selectedStatus: selectedStatus || 'ALL',
        selectedInvType: selectedInvType || 'ALL',
        selectedSourceType: sourceType || 'ALL',
        selectedUserId: userId,
        pageCount: pageCount,
        pageSize: pageSize,
        filters: filterData,
        sort: sortData,
        fromDateAndTime: fromDateAndTime,
        toDateAndTime: toDateAndTime,
        selectedConsolidatedStatus: conSolidatedData || 'ALL',
        ...(country == 'MY' && selectedCriteria == 'FileID' && { fileId: fileId })
      }

      const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
      const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
      return this.httpClient.post<any>(url, reqBody);
    } else {
      let reqs = new HttpParams();

      reqs = reqs.append('selectedCriteria', selectedCriteria || 'DataReceivedDate')
      if (selectedCriteria != 'FileID') {
        reqs = reqs.append('fromDataReceivedDate', fromDate || null)
        reqs = reqs.append('toDataReceivedDate', toDate || null)
      }
      reqs = reqs.append('filterType', 'S')
      reqs = reqs.append('selectedEntity', selectedEntity)
      reqs = reqs.append('selectedStatus', selectedStatus || 'ALL')
      reqs = reqs.append('selectedInvType', selectedInvType || 'ALL');
      reqs = reqs.append('selectedSourceType', sourceType || 'ALL');
      reqs = reqs.append('selectedUserId', userId);
      if (country == 'MY' && selectedCriteria == 'FileID') reqs = reqs.append('fileId', fileId);

      let header = new HttpHeaders({ 'country': country });

      const invoiceDashboardDataEndPoint = Constants.countryEndpoints[country];
      const url = `${Constants.APP_BASE_API_URL}/${invoiceDashboardDataEndPoint}`;
      return this.httpClient.post<any>(url, reqs, { headers: header });
    }
  }


  initiateBulkRequestToMofSystem(entityId: string, userId: string): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/initiateBulkRequestToMofSystem`;
    let reqs = new HttpParams();
    reqs = reqs.append('entityId', entityId)
    reqs = reqs.append('userId', userId);

    return this.httpClient.post<any>(url, reqs);
  }

  initiateRequestToMofSystem(responseIdList: string[], entityId: string, userId: string,selectedTab:any, requestUrl = "initiateRequestToMofSystem"): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/${requestUrl}`;
    this.userEmail =
    this.authService?.instance?.getActiveAccount()?.username.toLowerCase().length > 0
        ? this.authService?.instance?.getActiveAccount()?.username.toLowerCase()
        : this.storageService.deCodeJWT('preferred_username');
const httpOptions = {
    headers: new HttpHeaders({
        'Username': this.userEmail
    })
};
    let reqs = new HttpParams();
    reqs = reqs.append('responseIdList', responseIdList.toString())
    reqs = reqs.append('entityId', entityId)
    reqs = reqs.append('userId', userId);
    if(selectedTab == 2){
      reqs = reqs.append('isConsole', true);
    } else if (selectedTab === 'ERPT') {
      reqs = reqs.append('fileType', selectedTab);
    }
    return this.httpClient.post<any>(url, reqs,httpOptions);
  }

  initiateGenerateReport(selectedCriteria: string, fromDate: string, toDate: string,
    selectedEntity: string, reportCode: string, selectedStatus: string, selectedInvType: string, sourceType: string, userId: string,
    selectedTab:any,conSolidatedData:any, fromDateAndTime?, toDateAndTime?, timeZone?,fileId?:any, additionalParams?: any): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/initiateGenerateReport`;
    const selectedCountry = this.storageService.getWithDefaultPassphrase("Country");
    let reqs = new HttpParams();
    reqs = reqs.append('selectedCriteria', selectedCriteria || 'DataReceivedDate')
    if (selectedCriteria != 'FileID') {
      reqs = reqs.append('fromDataReceivedDate', fromDate || null)
      reqs = reqs.append('toDataReceivedDate', toDate || null)
    }
    const extra = additionalParams || {};

    reqs = reqs.append('filterType', extra.filterType || 'S')
    reqs = reqs.append('selectedEntity', selectedEntity)
    reqs = reqs.append('reportCode', reportCode)
    reqs = reqs.append('selectedStatus', selectedStatus || 'ALL')
    reqs = reqs.append('selectedInvType', selectedInvType || 'ALL')
    reqs = reqs.append('selectedUserId', userId);
    reqs = reqs.append('selectedSourceType', sourceType || 'ALL');
    reqs = reqs.append('fromDateAndTime', extra.fromDateAndTime || fromDateAndTime || null);
    reqs = reqs.append('toDateAndTime', extra.toDateAndTime || toDateAndTime || null);
    reqs = reqs.append('timeZone', timeZone || null);
    reqs = reqs.append('pageCount', extra.pageCount || '');
    reqs = reqs.append('pageSize', extra.pageSize || '');
    reqs = reqs.append('ppfStatus', extra.ppfStatus || '');
    reqs = reqs.append('documentNumber', extra.documentNumber || '');
    reqs = reqs.append('buyerName', extra.buyerName || '');
    reqs = reqs.append('buyerVatId', extra.buyerVatId || '');
    reqs = reqs.append('filters', extra.filters || '');
    reqs = reqs.append('sellerName', extra.sellerName || '');
    reqs = reqs.append('sellerVatId', extra.sellerVatId || '');
    reqs = reqs.append('currency', extra.currency || 'ALL');
    reqs = reqs.append('transactionType', extra.transactionType || 'ALL');
    reqs = reqs.append('transactionSubcategory', extra.transactionSubcategory || 'ALL');
    reqs = reqs.append('sort', extra.sort || '[]');
    reqs = reqs.append('lifecycleStatus', extra.lifecycleStatus || '');
    if(selectedTab == 2){
      reqs = reqs.append('selectedConsolidatedStatus', conSolidatedData || 'ALL');
    }
    if(selectedCountry === 'FR') {
      reqs = reqs.append('fileId', fileId || '');
    }else{
      // if (selectedCountry === 'MY' || selectedCountry === 'RO') {
        if (selectedCriteria.toLowerCase() === 'fileid' && fileId) {
          reqs = reqs.append('fileId', fileId);
        }
      // }
    }
    return this.httpClient.post<any>(url, reqs);
  }

  fetchDashboardDetailData(responseId: string, recordStatus: string, lang: string, type: string): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/getE-invoiceDashboardDetailData`;
    let reqs = new HttpParams();

    reqs = reqs.append('selectedResponseId', responseId || '')
    reqs = reqs.append('selectedRecordStatus', recordStatus || '')
    reqs = reqs.append('lang', lang)
    reqs = reqs.append('type', type)

    return this.httpClient.post<any>(url, reqs);

  }

  initiateUpoRequestToMof(selectedUpoInput: Array<GetUpoInput>, userId: string): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/initiateUpoRequestToMof`;

    return this.httpClient.post<any>(url, selectedUpoInput);
  }

  initiateGenerateReportForSelected(responseIdList: Array<ReportInput>, requestUrl = "initiateGenerateReportForSelected"): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/${requestUrl}`;
    let reqs = new HttpParams();
    return this.httpClient.post<any>(url, this.unicodeSafeBase64Encode(JSON.stringify(responseIdList)));
  }

  public getFetchMsgDate(fetchMessageLastCallRequest: FetchMessageLastCallRequest): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/getLastCallInfo`;
    let params = new HttpParams();

    params = params.append('requestType', fetchMessageLastCallRequest.requestType);
    params = params.append('entityId', fetchMessageLastCallRequest.entityId);

    return this.httpClient.post<any>(url, params);
  }

  public getFetchMsgList(fetchMessageLastCallRequest: FetchMessageLastCallRequest): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/fetchMessages`;
    return this.httpClient.post<any>(url, fetchMessageLastCallRequest);
  }

  public getInitiateFetchMsgDataReport(reqParams: any): Observable<any> {
    const url = `${Constants.APP_BASE_API_URL}/initiateFetchMessage`;
    let reqs = new HttpParams();
    reqs = reqs.appendAll(reqParams);
    return this.httpClient.post<any>(url, reqs);
  }



  initiateInvoiceCancellationIRBM(selectedInvoiceForCancellation, selectedCancellationReason) {
    const url = `${Constants.APP_BASE_API_URL}/initiateInvoiceCancellationIRBM`;
    let reqs = new HttpParams();
    reqs = reqs.append('responseIds', selectedInvoiceForCancellation.responseIds);
    reqs = reqs.append('fileIds', selectedInvoiceForCancellation.fileIds);
    reqs = reqs.append('userId', selectedInvoiceForCancellation.userId);
    reqs = reqs.append('entityId', selectedInvoiceForCancellation.entityId);
    reqs = reqs.append('cancellationReason', selectedCancellationReason)
    return this.httpClient.post<any>(url, reqs);
  }

  initiateInvoicedecline(selectedInvoiceForCancellation, selectedCancellationReason) {
    const url = `${Constants.APP_BASE_API_URL}/declineConsolidation`;
    let reqs = new HttpParams();
    reqs = reqs.append('responseIds', selectedInvoiceForCancellation.responseIds);
    // reqs = reqs.append('fileIds', selectedInvoiceForCancellation.fileIds);
    // reqs = reqs.append('userId', selectedInvoiceForCancellation.userId);
    // reqs = reqs.append('entityId', selectedInvoiceForCancellation.entityId);
    // reqs = reqs.append('cancellationReason', selectedCancellationReason)
    this.userEmail =
            this.authService?.instance?.getActiveAccount()?.username.toLowerCase().length > 0
                ? this.authService?.instance?.getActiveAccount()?.username.toLowerCase()
                : this.storageService.deCodeJWT('preferred_username');
        const httpOptions = {
            headers: new HttpHeaders({
                'Username': this.userEmail
            })
        };
    return this.httpClient.post<any>(url, reqs,httpOptions);
  }
}
